/**
 * 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 * Mevcut uygulama başlığındaki kelime markası ve ürün adı için ortak görünüm.
 * Ad, erişilebilir etiket ve gezinme davranışı çağıran ürünün sorumluluğundadır.
 */
import wordmarkUrl from '../../assets/QubeProLogo.svg';
import './ApplicationBrand.css';

export function ApplicationBrand({ label }: { label: string }) {
  return (
    <span className="application-brand">
      <img className="organization-logo-icon" src={wordmarkUrl} alt="QubePro" draggable={false} />
      <span className="organization-logo-text" title={label}>{label}</span>
    </span>
  );
}
